// list
export const FETCHING_VEHICLES_AVAILABILITY = '@@toyota/FETCHING_VEHICLES_AVAILABILITY';
export const FETCHED_VEHICLES_AVAILABILITY = '@@toyota/FETCHED_VEHICLES_AVAILABILITY';
export const FETCHED_VEHICLES_AVAILABILITY_FAILED = '@@toyota/FETCHED_VEHICLES_AVAILABILITY_FAILED';
export const FETCHING_ORDERS_BY_CHASSIS = '@@toyota/FETCHING_ORDERS_BY_CHASSIS';
export const FETCHED_ORDERS_BY_CHASSIS = '@@toyota/FETCHED_ORDERS_BY_CHASSIS';
export const FETCHED_ORDERS_BY_CHASSIS_FAILED = '@@toyota/FETCHED_ORDERS_BY_CHASSIS_FAILED';
export const UPDATING_AVAILABILITY_IN_VEHICLE = '@@toyota/UPDATING_AVAILABILITY_IN_VEHICLE';
export const UPDATED_AVAILABILITY_IN_VEHICLE = '@@toyota/UPDATED_AVAILABILITY_IN_VEHICLE';
export const UPDATED_AVAILABILITY_IN_VEHICLE_FAILED = '@@toyota/UPDATED_AVAILABILITY_IN_VEHICLE_FAILED';
